.standaloneWrapper {
	width: 100%;
	min-height: 100vh;
}
